import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportContentService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: any): any {
    return this.http.post(`${environment.apiUrl}/Review/GetReportedContentList`, filter);
  }
  GetDetails(id: number) {
    return this.http.get(`${environment.apiUrl}/Review/GetReportByID?reportId=${id}`);
  }
  delete(id: string) {
    return this.http.get(`${environment.apiUrl}/Review/Delete?id=${id}`);
  }
  saveRecord(data: any) {
    return this.http.post(`${environment.apiUrl}/Review/SendReportDecision`, data);
  }
}
